<template>
  <loading v-model:active="isLoading" :can-cancel="false" :is-full-page="true" />
  <h4>
    Editar cadastro
    <button
      data-toggle="modal"
      data-target="#alterar-senha"
      class="btn btn-primary btn-sm"
      style="margin-left: 15px"
      @click="(senha_atual = null), (nova_senha = null), (alterar_senha = true)"
      type="button"
    >
      Alterar senha
    </button>
  </h4>
  <br />

  <div class="card">
    <div class="card-header" v-if="formData.cadastro_tipo == 'pj'">
      <h5 class="card-title" id="accordion">
        <i class="fas fa-building"></i>
        &nbsp; DADOS DA EMPRESA
      </h5>
    </div>

    <div class="card-body" v-if="formData.cadastro_tipo == 'pj'">
      <div class="row">
        <div class="col-sm-12">
          <div class="form-group">
            <label for="nome">Razão social</label>
            <input class="form-control" id="id" v-model="formData.pj_razao_social" style="text-transform: uppercase" />

            <span style="color: red" v-for="error in v$.pj_razao_social.$errors" :key="error.$uid">
              {{ error.$message }}
            </span>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="form-group">
            <label for="nome">Nome fantasia</label>
            <input class="form-control" id="id" v-model="formData.pj_nome_fantasia" style="text-transform: uppercase" />

            <span style="color: red" v-for="error in v$.pj_nome_fantasia.$errors" :key="error.$uid">
              {{ error.$message }}
            </span>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="form-group">
            <label for="nome">CNPJ</label>

            <InputMask id="basic" class="form-control" v-model="formData.pj_cnpj" mask="99.999.999/9999-99" />

            <span style="color: red" v-for="error in v$.pj_cnpj.$errors" :key="error.$uid">
              {{ error.$message }}
            </span>
          </div>
        </div>

        <!-- ENDERECO CEP -->
        <div class="col-sm-2">
          <div class="form-group">
            <label for="pj_endereco_cep">CEP</label>

            <div class="input-group">
              <InputMask id="basic" class="form-control" v-model="formData.pj_endereco_cep" placeholder="_______-___" mask="99999-999" />

              <span class="input-group-append">
                <button @click="buscarCepPJ()" type="button" class="btn btn-info btn-flat"><i class="fa fa-search"></i></button>
              </span>
            </div>

            <span style="color: red" v-for="error in v$.pj_endereco_cep.$errors" :key="error.$uid">
              {{ error.$message }}
            </span>
          </div>
        </div>

        <div class="col-sm-4">
          <div class="form-group">
            <label for="nome">Endereço</label>
            <input class="form-control" id="id" v-model="formData.pj_endereco" style="text-transform: uppercase" />

            <span style="color: red" v-for="error in v$.pj_endereco.$errors" :key="error.$uid">
              {{ error.$message }}
            </span>
          </div>
        </div>

        <div class="col-sm-3">
          <div class="form-group">
            <label for="nome">Número</label>
            <input class="form-control" id="id" v-model="formData.pj_endereco_num" style="text-transform: uppercase" />

            <span style="color: red" v-for="error in v$.pj_endereco_num.$errors" :key="error.$uid">
              {{ error.$message }}
            </span>
          </div>
        </div>

        <div class="col-sm-3">
          <div class="form-group">
            <label for="nome">Bairro</label>
            <input class="form-control" id="id" v-model="formData.pj_endereco_bairro" style="text-transform: uppercase" />

            <span style="color: red" v-for="error in v$.pj_endereco_bairro.$errors" :key="error.$uid">
              {{ error.$message }}
            </span>
          </div>
        </div>

        <div class="col-sm-3">
          <div class="form-group">
            <label for="endereco_cidade">Cidade</label>

            <select class="custom-select rounded-0" id="endereco_cidade" v-model="formData.pj_cidade_id" style="text-transform: uppercase">
              <option v-for="cidade in my_cidades_pj" :key="cidade.id" :value="cidade.id">
                {{ cidade.nome }}
              </option>
            </select>

            <span style="color: red" v-for="error in v$.pj_cidade_id.$errors" :key="error.$uid">
              {{ error.$message }}
            </span>
          </div>
        </div>

        <div class="col-sm-3">
          <div class="form-group">
            <label for="endereco_estado">UF</label>

            <select
              class="custom-select rounded-0"
              id="endereco_estado"
              v-model="formData.pj_estado_id"
              style="text-transform: uppercase"
              @change="buscarCidadePJ()"
            >
              <option v-for="estado in estados" :key="estado.id" :value="estado.id">
                {{ estado.nome }}
              </option>
            </select>

            <span style="color: red" v-for="error in v$.pj_estado_id.$errors" :key="error.$uid">
              {{ error.$message }}
            </span>
          </div>
        </div>

        <div class="col-sm-6">
          <div class="form-group">
            <label for="endereco_estado">Complemento</label>
            <input class="form-control" id="id" v-model="formData.pj_endereco_complemento" style="text-transform: uppercase" />

            <span style="color: red" v-for="error in v$.pj_endereco_complemento.$errors" :key="error.$uid">
              {{ error.$message }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="card-header">
      <h5 v-if="formData.cadastro_tipo == 'pf'" class="card-title" id="accordion">
        <i class="fas fa-user"></i>
        &nbsp; DADOS CADASTRAIS
      </h5>
      <h5 v-else class="card-title" id="accordion">
        <i class="fas fa-user"></i>
        &nbsp; DADOS DO REPRESENTANTE LEGAL
      </h5>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-sm-3">
          <div class="form-group">
            <label for="nome">Nome</label>
            <input class="form-control" id="id" v-model="formData.nome_completo" style="text-transform: uppercase" />

            <span style="color: red" v-for="error in v$.nome_completo.$errors" :key="error.$uid">
              {{ error.$message }}
            </span>
          </div>
        </div>
        <div class="col-sm-2">
          <div class="form-group">
            <label for="nome">CPF</label>
            <InputMask
              @blur="validateCPF"
              id="basic"
              class="form-control"
              v-model="formData.cpf"
              placeholder="___.___.___-__"
              mask="999.999.999-99"
            />

            <span style="color: red" v-for="error in errors.cpf" :key="error">
              {{ error }}
            </span>

            <span style="color: red" v-for="error in v$.cpf.$errors" :key="error.$uid">
              {{ error.$message }}
            </span>
          </div>
        </div>
        <div class="col-sm-2">
          <div class="form-group">
            <label for="nome">RG</label>
            <input class="form-control" id="id" v-model="formData.rg" style="text-transform: uppercase" />

            <span style="color: red" v-for="error in v$.rg.$errors" :key="error.$uid">
              {{ error.$message }}
            </span>
          </div>
        </div>
        <div class="col-sm-3">
          <div class="form-group">
            <label for="conjuge_orgao_expedidor">Orgão Exp</label>

            <input class="form-control" id="id" v-model="formData.orgao_expedidor_id" style="text-transform: uppercase" />

            <span style="color: red" v-for="error in v$.orgao_expedidor_id.$errors" :key="error.$uid">
              {{ error.$message }}
            </span>
          </div>
        </div>

        <div class="col-sm-2">
          <div class="form-group">
            <label for="nome">Data emissão</label>

            <InputMask
              id="basic"
              class="form-control"
              v-model="formData.rg_data_emissao"
              placeholder="DD/MM/AAAA"
              mask="99/99/9999"
              slotChar="dd/mm/yyyy"
            />

            <span style="color: red" v-for="error in v$.rg_data_emissao.$errors" :key="error.$uid">
              {{ error.$message }}
            </span>
          </div>
        </div>

        <div class="col-sm-4">
          <div class="form-group">
            <label for="nome">Nascimento</label>

            <InputMask
              id="basic"
              class="form-control"
              v-model="formData.data_nascimento"
              placeholder="DD/MM/AAAA"
              mask="99/99/9999"
              slotChar="dd/mm/yyyy"
            />

            <span style="color: red" v-for="error in v$.data_nascimento.$errors" :key="error.$uid">
              {{ error.$message }}
            </span>
          </div>
        </div>

        <div class="col-sm-4">
          <div class="form-group">
            <label for="nome">Nacionalidade</label>
            <input class="form-control" id="id" v-model="formData.nacionalidade" style="text-transform: uppercase" />

            <span style="color: red" v-for="error in v$.nacionalidade.$errors" :key="error.$uid">
              {{ error.$message }}
            </span>
          </div>
        </div>

        <div class="col-sm-4">
          <div class="form-group">
            <label for="nome">Naturalidade</label>
            <input class="form-control" id="id" v-model="formData.naturalidade" style="text-transform: uppercase" />

            <span style="color: red" v-for="error in v$.naturalidade.$errors" :key="error.$uid">
              {{ error.$message }}
            </span>
          </div>
        </div>

        <div class="col-sm-4">
          <div class="form-group">
            <label for="nome">Filiação completa</label>
            <input class="form-control" id="id" v-model="formData.filiacao" style="text-transform: uppercase" />

            <span style="color: red" v-for="error in v$.filiacao.$errors" :key="error.$uid">
              {{ error.$message }}
            </span>
          </div>
        </div>

        <div class="col-sm-4">
          <div class="form-group">
            <label for="nome">Sexo</label>

            <select class="custom-select rounded-0" id="sexo" v-model="formData.sexo">
              <option value="feminino">FEMININO</option>
              <option value="masculino">MASCULINO</option>
            </select>

            <span style="color: red" v-for="error in v$.sexo.$errors" :key="error.$uid">
              {{ error.$message }}
            </span>
          </div>
        </div>

        <div class="col-sm-4">
          <div class="form-group">
            <label for="estado_civil">Estado civil</label>

            <select class="custom-select rounded-0" id="estado_civil" v-model="formData.estado_civil" style="text-transform: uppercase">
              <option value="casado">Casado</option>
              <option value="divorciado">Divorciado</option>
              <option value="separado_judicialmente">Separado judicialmente</option>
              <option value="solteiro_com_uniao_estavel">Solteiro com união estável</option>
              <option value="solteiro_sem_uniao_estavel">Solteiro sem união estável</option>
              <option value="viuvo">Viúvo</option>
            </select>

            <span style="color: red" v-for="error in v$.estado_civil.$errors" :key="error.$uid">
              {{ error.$message }}
            </span>
          </div>
        </div>

        <div class="col-sm-2">
          <div class="form-group">
            <label for="nome">CEP</label>

            <div class="input-group">
              <InputMask id="basic" class="form-control" v-model="formData.endereco_cep" placeholder="_______-___" mask="99999-999" />

              <span class="input-group-append">
                <button @click="buscarCep()" type="button" class="btn btn-info btn-flat"><i class="fa fa-search"></i></button>
              </span>
            </div>

            <span style="color: red" v-for="error in v$.endereco_cep.$errors" :key="error.$uid">
              {{ error.$message }}
            </span>
          </div>
        </div>

        <div class="col-sm-4">
          <div class="form-group">
            <label for="nome">Endereço</label>
            <input class="form-control" id="id" v-model="formData.endereco" style="text-transform: uppercase" />

            <span style="color: red" v-for="error in v$.endereco.$errors" :key="error.$uid">
              {{ error.$message }}
            </span>
          </div>
        </div>

        <div class="col-sm-3">
          <div class="form-group">
            <label for="nome">Número</label>
            <input class="form-control" id="id" v-model="formData.endereco_num" style="text-transform: uppercase" />

            <span style="color: red" v-for="error in v$.endereco_num.$errors" :key="error.$uid">
              {{ error.$message }}
            </span>
          </div>
        </div>

        <div class="col-sm-3">
          <div class="form-group">
            <label for="nome">Bairro</label>
            <input class="form-control" id="id" v-model="formData.endereco_bairro" style="text-transform: uppercase" />

            <span style="color: red" v-for="error in v$.endereco_bairro.$errors" :key="error.$uid">
              {{ error.$message }}
            </span>
          </div>
        </div>

        <!-- ENDERECO COMPLEMENTO -->
        <div class="col-sm-3">
          <div class="form-group">
            <label for="endereco_cidade">Complemento</label>

            <input class="form-control" id="id" v-model="formData.endereco_complemento" style="text-transform: uppercase" />
          </div>
        </div>

        <!-- ENDERECO CIDADE -->
        <div class="col-sm-3">
          <div class="form-group">
            <label for="endereco_cidade">Cidade</label>

            <select class="custom-select rounded-0" id="endereco_cidade" v-model="formData.cidade_id" style="text-transform: uppercase">
              <option v-for="cidade in my_cidades" :key="cidade.id" :value="cidade.id">
                {{ cidade.nome }}
              </option>
            </select>

            <span style="color: red" v-for="error in v$.cidade_id.$errors" :key="error.$uid">
              {{ error.$message }}
            </span>
          </div>
        </div>

        <!-- ENDERECO ESTADO -->
        <div class="col-sm-3">
          <div class="form-group">
            <label for="endereco_estado">UF</label>

            <select
              class="custom-select rounded-0"
              id="endereco_estado"
              v-model="formData.estado_id"
              @change="buscarCidades()"
              style="text-transform: uppercase"
            >
              <option v-for="estado in estados" :key="estado.id" :value="estado.id">
                {{ estado.nome }}
              </option>
            </select>

            <span style="color: red" v-for="error in v$.estado_id.$errors" :key="error.$uid">
              {{ error.$message }}
            </span>
          </div>
        </div>

        <div class="col-sm-3">
          <div class="form-group">
            <label for="nome">Fone</label>
            <!--<InputMask placeholder="(__)_____-____" id="basic" class="form-control" v-model="formData.telefone_fixo" mask="(99)99999-9999" /> -->

            <input class="form-control" v-model="formData.telefone_fixo" />

            <span v-if="formData.telefone_fixo" style="color: red" v-for="error in v$.telefone_fixo.$errors" :key="error.$uid">
              {{ error.$message }}
            </span>
          </div>
        </div>

        <div class="col-sm-6">
          <div class="form-group">
            <label for="nome">Profissão</label>
            <input class="form-control" id="id" v-model="formData.profissao" style="text-transform: uppercase" />

            <span style="color: red" v-for="error in v$.profissao.$errors" :key="error.$uid">
              {{ error.$message }}
            </span>
          </div>
        </div>

        <div class="col-sm-6">
          <div class="form-group">
            <label for="nome">Apelido</label>
            <input disabled class="form-control" id="id" v-model="formData.apelido" style="text-transform: uppercase" />

            <span style="color: red" v-for="error in v$.apelido.$errors" :key="error.$uid">
              {{ error.$message }}
            </span>
          </div>
        </div>

        <div class="col-sm-6">
          <div class="form-group">
            <label for="nome">E-mail</label>
            <input disabled="true" class="form-control" id="id" v-model="user.email" />
          </div>
        </div>

        <div class="col-sm-6">
          <div class="form-group">
            <label for="nome">Celular</label>
            <!--<input class="form-control" id="id" v-model="formData.telefone_celular" style="text-transform: uppercase" /> -->
            <InputMask id="basic" class="form-control" v-model="formData.telefone_celular" placeholder="(__)_____-____" mask="(99)99999-9999" />

            <span style="color: red" v-for="error in errors.telefone_celular" :key="error">
              {{ error }}
            </span>

            <span style="color: red" v-for="error in v$.telefone_celular.$errors" :key="error.$uid">
              {{ error.$message }}
            </span>
          </div>
        </div>

        <div
          class="row p-2"
          v-if="
            (formData.estado_civil == 'casado' ||
              formData.estado_civil == 'uniao_estavel' ||
              formData.estado_civil == 'solteiro_com_uniao_estavel') &&
            formData.cadastro_tipo == 'pf'
          "
        >
          <div class="col-sm-12">
            <br />
            <h6>
              <i class="fa-solid fa-ring" style="margin-right: 7px"></i>
              DADOS DO CÔNJUGE
            </h6>
            <hr />
          </div>

          <div class="col-sm-12">
            <div class="form-group">
              <label for="regime_casamento">Regime do casamento</label>
              <select class="custom-select rounded-0" id="regime_casamento" v-model="formData.regime_casamento" style="text-transform: uppercase">
                <option value="cpb">Comunhão parcial de bens</option>
                <option value="cub">Comunhão universal de bens</option>
                <option value="outros">Outros</option>
                <option value="pfa">Participação final nos aquestos</option>
                <option value="seb">Separação de bens</option>
              </select>

              <span style="color: red" v-for="error in v$.regime_casamento.$errors" :key="error.$uid">
                {{ error.$message }}
              </span>
            </div>
          </div>

          <div class="col-sm-3">
            <div class="form-group">
              <label for="nome">Nome</label>
              <input class="form-control" id="id" v-model="formData.conjuge_nome_completo" style="text-transform: uppercase" />

              <span style="color: red" v-for="error in v$.conjuge_nome_completo.$errors" :key="error.$uid">
                {{ error.$message }}
              </span>
            </div>
          </div>
          <div class="col-sm-2">
            <div class="form-group">
              <label for="nome">CPF</label>

              <InputMask id="basic" class="form-control" v-model="formData.conjuge_cpf" placeholder="___.___.___-__" mask="999.999.999-99" />

              <span style="color: red" v-for="error in errors.conjuge_cpf" :key="error">
                {{ error }}
              </span>

              <span style="color: red" v-for="error in v$.conjuge_cpf.$errors" :key="error.$uid">
                {{ error.$message }}
              </span>
            </div>
          </div>
          <div class="col-sm-2">
            <div class="form-group">
              <label for="nome">RG</label>
              <input class="form-control" id="id" v-model="formData.conjuge_rg" style="text-transform: uppercase" />

              <span style="color: red" v-for="error in v$.conjuge_rg.$errors" :key="error.$uid">
                {{ error.$message }}
              </span>
            </div>
          </div>

          <div class="col-sm-3">
            <div class="form-group">
              <label for="conjuge_orgao_expedidor">Orgão expedidor (Cônjuge)</label>

              <input class="form-control" id="id" v-model="formData.conjuge_orgao_expedidor_id" style="text-transform: uppercase" />

              <span style="color: red" v-for="error in v$.conjuge_orgao_expedidor_id.$errors" :key="error.$uid">
                {{ error.$message }}
              </span>
            </div>
          </div>

          <div class="col-sm-2">
            <div class="form-group">
              <label for="nome">Data emissão</label>

              <InputMask
                id="basic"
                class="form-control"
                v-model="formData.conjuge_rg_data_emissao"
                placeholder="__/__/____"
                mask="99/99/9999"
                slotChar="dd/mm/yyyy"
              />

              <span style="color: red" v-for="error in v$.conjuge_rg_data_emissao.$errors" :key="error.$uid">
                {{ error.$message }}
              </span>
            </div>
          </div>

          <div class="col-sm-4">
            <div class="form-group">
              <label for="nome">Nascimento</label>

              <InputMask
                id="basic"
                class="form-control"
                v-model="formData.conjuge_data_nascimento"
                placeholder="__/__/____"
                mask="99/99/9999"
                slotChar="dd/mm/yyyy"
              />

              <span style="color: red" v-for="error in v$.conjuge_data_nascimento.$errors" :key="error.$uid">
                {{ error.$message }}
              </span>
            </div>
          </div>

          <div class="col-sm-4">
            <div class="form-group">
              <label for="nome">Nacionalidade</label>
              <input class="form-control" id="id" v-model="formData.conjuge_nacionalidade" style="text-transform: uppercase" />

              <span style="color: red" v-for="error in v$.conjuge_nacionalidade.$errors" :key="error.$uid">
                {{ error.$message }}
              </span>
            </div>
          </div>

          <div class="col-sm-4">
            <div class="form-group">
              <label for="conjuge_naturalidade">Naturalidade (Cidade/Estado)</label>

              <input
                style="text-transform: uppercase"
                type="text"
                class="form-control"
                id="conjuge_naturalidade"
                v-model="formData.conjuge_naturalidade"
              />

              <span style="color: red" v-for="error in v$.conjuge_naturalidade.$errors" :key="error.$uid">
                {{ error.$message }}
              </span>
            </div>
          </div>

          <div class="col-sm-4">
            <div class="form-group">
              <label for="nome">Profissão</label>
              <input class="form-control" id="id" v-model="formData.conjuge_profissao" style="text-transform: uppercase" />

              <span style="color: red" v-for="error in v$.conjuge_profissao.$errors" :key="error.$uid">
                {{ error.$message }}
              </span>
            </div>
          </div>

          <div class="col-sm-4">
            <div class="form-group">
              <label for="nome">Filiação completa</label>
              <input class="form-control" id="id" v-model="formData.conjuge_filiacao" style="text-transform: uppercase" />

              <span style="color: red" v-for="error in v$.conjuge_filiacao.$errors" :key="error.$uid">
                {{ error.$message }}
              </span>
            </div>
          </div>

          <div class="col-sm-4">
            <div class="form-group">
              <label for="nome">Sexo</label>

              <select class="custom-select rounded-0" id="sexo" v-model="formData.conjuge_sexo">
                <option value="feminino">FEMININO</option>
                <option value="masculino">MASCULINO</option>
              </select>

              <span style="color: red" v-for="error in v$.conjuge_sexo.$errors" :key="error.$uid">
                {{ error.$message }}
              </span>
            </div>
          </div>
        </div>

        <div
          class="row p-2"
          v-if="
            (formData.estado_civil == 'casado' ||
              formData.estado_civil == 'uniao_estavel' ||
              formData.estado_civil == 'solteiro_com_uniao_estavel') &&
            formData.cadastro_tipo == 'pj'
          "
        >
          <div class="col-sm-12">
            <br />
            <h6>
              <i class="fa-solid fa-ring" style="margin-right: 7px"></i>
              DADOS DO CÔNJUGE
            </h6>
            <hr />
          </div>

          <div class="col-sm-12">
            <div class="form-group">
              <label for="regime_casamento">Regime do casamento</label>
              <select class="custom-select rounded-0" id="regime_casamento" v-model="formData.regime_casamento" style="text-transform: uppercase">
                <option value="cpb">Comunhão parcial de bens</option>
                <option value="cub">Comunhão universal de bens</option>
                <option value="outros">Outros</option>
                <option value="pfa">Participação final nos aquestos</option>
                <option value="seb">Separação de bens</option>
              </select>

              <span style="color: red" v-for="error in v$.regime_casamento.$errors" :key="error.$uid">
                {{ error.$message }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div>
        <button @click="validateFields()" class="btn btn-primary btn-sm">
          Salvar
          <i class="fa fa-check"></i>
        </button>
      </div>
    </div>
  </div>

  <!-- MODAL CADASTRAR PUBLICAÇÃO -->
  <div
    class="modal fade"
    id="alterar-senha"
    tabindex="-1"
    role="dialog"
    aria-labelledby="myModalLabel"
    aria-hidden="true"
    @click.self="alterar_senha = false"
    @keydown.esc="alterar_senha = false"
  >
    <form @submit.prevent>
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body" v-if="alterar_senha">
            <alterar-senha :user="user" :closeModal="closeModal" />
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import sweetAlert from "../../controller/sweetAlert";
import Swal from "sweetalert2/dist/sweetalert2.js";
import AuxController from "../../mixins/auxController.js";
import Loading from "vue-loading-overlay";
import moment from "moment";
import "vue-loading-overlay/dist/vue-loading.css";
import InputMask from "primevue/inputmask";

import useVueLidate from "@vuelidate/core";
import { email, sameAs, helpers } from "@vuelidate/validators";
import { required, minLength, maxLength } from "../../locales/i18n.js";
import { computed, reactive } from "vue";

export default {
  props: ["user_profile", "user", "cidades", "cidades_pj", "estados", "orgaos_expedidores_rg"],

  mixins: [sweetAlert, Swal, AuxController],

  components: { Loading, InputMask },

  setup() {
    const formData = reactive({
      apelido: "",
      telefone_fixo: "",
      telefone_celular: "",
      filiacao: "",
      cadastro_tipo: "pf",
      nome_completo: "",
      conjuge_cpf: "",
      conjuge_rg: "",
      conjuge_orgao_expedidor_id: "",
      conjuge_rg_data_emissao: "",
      conjuge_naturalidade: "",
      conjuge_nacionalidade: "",
      conjuge_data_nascimento: "",
      conjuge_sexo: "",
      conjuge_profissao: "",
      conjuge_filiacao: "",
      cpf: "",
      rg: "",
      orgao_expedidor_id: "",
      rg_data_emissao: "",
      naturalidade: "",
      nacionalidade: "",
      data_nascimento: "",
      sexo: "",
      estado_civil: "",
      endereco_cep: "",
      endereco_num: "",
      endereco_complemento: "",
      endereco_bairro: "",
      endereco: "",
      endereco_estado: "",
      estado_id: "",
      cidade_id: "",
      regime_casamento: "",
      user_email: "",
      profissao: "",
      pj_razao_social: "",
      pj_nome_fantasia: "",
      pj_cnpj: "",
      pj_endereco: "",
      pj_endereco_cep: "",
      pj_endereco_num: "",
      pj_endereco_complemento: "",
      pj_endereco_bairro: "",
      pj_estado_id: "",
      pj_cidade_id: "",
    });

    const rules = computed(() => {
      let local_rules = {
        apelido: { required },
        user_email: { required },
        filiacao: { required },
        telefone_fixo: { maxLength: maxLength(20) },
        telefone_celular: {
          required,
          minLength: minLength(11),
        },
        cadastro_tipo: { required },
        nome_completo: { required },
        orgao_expedidor_id: { required },
        cpf: { required, validarCPF: helpers.withMessage(" Digite um CPF válido.", validarCPF) },
        rg: {
          required,
        },
        rg_data_emissao: {
          required,
          validDate: helpers.withMessage(" Digite uma data válida.", validDate),
          minDate: helpers.withMessage(" A data não pode ser maior que hoje.", minDate),
        },
        naturalidade: { required },
        nacionalidade: { required },
        data_nascimento: {
          required,
          validDate: helpers.withMessage(" Digite uma data válida.", validDate),
          minDate: helpers.withMessage(" A data não pode ser maior que hoje.", minDate),
        },
        sexo: { required },
        estado_civil: { required, validarEstadoCivil: helpers.withMessage(" Esse estado civil não está mais disponível.", validarEstadoCivil) },
        endereco_cep: { required },
        cidade_id: { required },
        estado_id: { required },
        endereco: { required },
        endereco_bairro: { required },
        endereco_num: { required },
        profissao: { required },
      };

      if (formData.cadastro_tipo == "pj") {
        local_rules.pj_endereco_complemento = {
          required,
        };
        local_rules.pj_razao_social = {
          required,
        };
        local_rules.pj_nome_fantasia = {
          required,
        };
        local_rules.pj_cnpj = {
          required,
          validarCPF: helpers.withMessage(" Digite um CNPJ válido.", validarCNPJ),
        };
      }
      if (
        (formData.estado_civil == "casado" || formData.estado_civil == "uniao_estavel" || formData.estado_civil == "solteiro_com_uniao_estavel") &&
        formData.cadastro_tipo == "pf"
      ) {
        local_rules.conjuge_nome_completo = {
          required,
        };
        local_rules.conjuge_orgao_expedidor_id = {
          required,
        };
        local_rules.conjuge_cpf = {
          required,
          checkCFPConjuge: helpers.withMessage(" Digite um CPF diferente", checkCFPConjuge),
          validarCPF: helpers.withMessage(" Digite um CPF válido.", validarCPF),
        };
        local_rules.conjuge_rg = {
          required,
          validarRG: helpers.withMessage(" Digite um RG diferente.", validarRG),
        };
        local_rules.conjuge_rg_data_emissao = {
          required,
          validDate: helpers.withMessage(" Digite uma data válida.", validDate),
          minDate: helpers.withMessage(" A data não pode ser maior que hoje.", minDate),
        };
        local_rules.conjuge_data_nascimento = {
          required,
          validDate: helpers.withMessage(" Digite uma data válida.", validDate),
          minDate: helpers.withMessage(" A data não pode ser maior que hoje.", minDate),
        };
        local_rules.conjuge_naturalidade = {
          required,
        };
        local_rules.conjuge_nacionalidade = {
          required,
        };
        local_rules.conjuge_sexo = {
          required,
        };
        local_rules.conjuge_profissao = {
          required,
        };
        local_rules.conjuge_filiacao = {
          required,
        };
        local_rules.regime_casamento = {
          required,
        };
      }

      if (
        (formData.estado_civil == "casado" || formData.estado_civil == "uniao_estavel" || formData.estado_civil == "solteiro_com_uniao_estavel") &&
        formData.cadastro_tipo == "pj"
      ) {
        local_rules.regime_casamento = {
          required,
        };
      }

      if (formData.cadastro_tipo == "pj") {
        local_rules.pj_endereco = {
          required,
        };
        local_rules.pj_endereco_cep = {
          required,
        };
        local_rules.pj_endereco_num = {
          required,
        };
        local_rules.pj_endereco_bairro = {
          required,
        };
        local_rules.pj_estado_id = {
          required,
        };
        local_rules.pj_cidade_id = {
          required,
        };
      }

      return local_rules;
    });

    const validDate = (value) => {
      return moment(value, "DD/MM/yyyy").format("yyyy-MM-DD") != "Invalid date";
    };

    const validarEstadoCivil = (estado_civil) => {
      if (estado_civil == "solteiro" || estado_civil == "uniao_estavel") {
        return false;
      } else {
        return true;
      }
    };

    const validarCNPJ = (cnpj) => {
      var b = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
      var c = String(cnpj).replace(/[^\d]/g, "");

      if (c.length !== 14) return false;

      if (/0{14}/.test(c)) return false;

      for (var i = 0, n = 0; i < 12; n += c[i] * b[++i]);
      if (c[12] != ((n %= 11) < 2 ? 0 : 11 - n)) return false;

      for (var i = 0, n = 0; i <= 12; n += c[i] * b[i++]);
      if (c[13] != ((n %= 11) < 2 ? 0 : 11 - n)) return false;

      return true;
    };

    const checkCFPConjuge = (cpf) => {
      return cpf != formData.cpf;
    };

    const validarRG = (rg) => {
      let rg_comparacao = "";
      let rg_informado = rg.toUpperCase().replace(/[^\w\s]/gi, "");

      if (formData.rg) {
        rg_comparacao = formData.rg.toUpperCase().replace(/[^\w\s]/gi, "");
      }

      return rg_informado != rg_comparacao;
    };

    //DATA MENOR QUE HOJE
    const minDate = (date) => {
      if (moment(date, "DD/MM/yyyy").format("yyyy-MM-DD") != "Invalid date") {
        let data = new Date(moment(date, "DD/MM/yyyy"));

        return data < new Date();
      } else {
        return true;
      }
    };

    const minBirthDate = (date) => {
      return new Date(date) >= new Date("01-01-1940");
    };

    const validaConjuge = (estado_civil, sibling) => {
      console.log("SIB");
      console.log(sibling.estado_civil);
      if (sibling.estado_civil && sibling.estado_civil == "casado") {
        console.log("Entrou no if");
        return true;
      } else {
        console.log("Entrou no else");
        return false;
      }
    };

    const validarCPF = (cpf) => {
      cpf = cpf.replace(/\D/g, "");
      if (cpf.toString().length != 11 || /^(\d)\1{10}$/.test(cpf)) return false;
      var result = true;
      [9, 10].forEach(function (j) {
        var soma = 0,
          r;
        cpf
          .split(/(?=)/)
          .splice(0, j)
          .forEach(function (e, i) {
            soma += parseInt(e) * (j + 2 - (i + 1));
          });
        r = soma % 11;
        r = r < 2 ? 0 : 11 - r;
        if (r != cpf.substring(j, j + 1)) result = false;
      });
      return result;
    };

    const v$ = useVueLidate(rules, formData);

    return { formData, v$ };
  },

  data() {
    return {
      alterar_senha: false,
      isLoading: false,
      my_cidades: [],
      errors: [],
      senha_atual: "",
      nova_senha: "",
    };
  },

  mounted() {
    this.errors = {
      telefone_celular: [],
    };

    console.log("Editar cadastro");
    console.log(this.user_profile);
    console.log(this.user);
    this.my_cidades_pj = this.cidades_pj;
    this.my_cidades = this.cidades;
    this.formData.apelido = this.user.apelido;
    this.formData.user_email = this.user.email;
    this.formData.profissao = this.user_profile.profissao;
    this.formData.cidade_id = this.user_profile.cidade_id;
    this.formData.estado_id = this.user_profile.estado_id;
    this.formData.telefone_fixo = this.user_profile.telefone_fixo;
    this.formData.telefone_celular = this.user_profile.telefone_celular;
    this.formData.filiacao = this.user_profile.filiacao;
    this.formData.cadastro_tipo = this.user_profile.cadastro_tipo;
    this.formData.nome_completo = this.user_profile.nome_completo;
    this.formData.conjuge_nome_completo = this.user_profile.conjuge_nome_completo;
    this.formData.conjuge_cpf = this.user_profile.conjuge_cpf;
    this.formData.conjuge_rg = this.user_profile.conjuge_rg;
    this.formData.conjuge_orgao_expedidor_id = this.user_profile.conjuge_rg_orgao_exp;
    this.formData.conjuge_rg_data_emissao = this.formatFromDb(this.user_profile.conjuge_rg_data_emissao);
    this.formData.conjuge_naturalidade = this.user_profile.conjuge_naturalidade;
    this.formData.conjuge_nacionalidade = this.user_profile.conjuge_nacionalidade;
    this.formData.conjuge_data_nascimento = this.formatFromDb(this.user_profile.conjuge_data_nascimento);
    this.formData.conjuge_sexo = this.user_profile.conjuge_sexo;
    this.formData.conjuge_profissao = this.user_profile.conjuge_profissao;
    this.formData.conjuge_filiacao = this.user_profile.conjuge_filiacao;
    this.formData.cpf = this.user_profile.cpf;
    this.formData.rg = this.user_profile.rg;
    this.formData.orgao_expedidor_id = this.user_profile.rg_orgao_exp;
    this.formData.rg_data_emissao = this.formatFromDb(this.user_profile.rg_data_emissao);
    this.formData.naturalidade = this.user_profile.naturalidade;
    this.formData.nacionalidade = this.user_profile.nacionalidade;
    this.formData.data_nascimento = this.formatFromDb(this.user_profile.data_nascimento);
    this.formData.sexo = this.user_profile.sexo;
    this.formData.estado_civil = this.user_profile.estado_civil;
    this.formData.endereco_cep = this.user_profile.endereco_cep;
    this.formData.endereco_num = this.user_profile.endereco_num;
    this.formData.endereco_complemento = this.user_profile.endereco_complemento;
    this.formData.endereco_bairro = this.user_profile.endereco_bairro;
    this.formData.endereco = this.user_profile.endereco;
    this.formData.endereco_estado = this.user_profile.endereco_estado;
    this.formData.endereco_estado_id = this.user_profile.endereco_estado_id;
    this.formData.endereco_cidade = this.user_profile.endereco_cidade;
    this.formData.endereco_cidade_id = this.user_profile.endereco_cidade_id;
    this.formData.regime_casamento = this.user_profile.regime_casamento;
    this.formData.pj_razao_social = this.user_profile.pj_razao_social;
    this.formData.pj_nome_fantasia = this.user_profile.pj_nome_fantasia;
    this.formData.pj_cnpj = this.user_profile.pj_cnpj;
    this.formData.pj_endereco = this.user_profile.pj_endereco;
    this.formData.pj_endereco_cep = this.user_profile.pj_endereco_cep;
    this.formData.pj_endereco_num = this.user_profile.pj_endereco_num;
    this.formData.pj_endereco_complemento = this.user_profile.pj_endereco_complemento;
    this.formData.pj_endereco_bairro = this.user_profile.pj_endereco_bairro;
    this.formData.pj_estado_id = this.user_profile.pj_estado_id;
    this.formData.pj_cidade_id = this.user_profile.pj_cidade_id;
  },

  methods: {
    buscarCepPJ() {
      this.isLoading = true;
      this.cep_valido = false;

      let cep = this.formData.pj_endereco_cep.replace(/[^Z0-9]/g, "");

      axios
        .get("https://viacep.com.br/ws/" + cep + "/json/")
        .then((response) => {
          this.isLoading = false;

          console.log(response.data);

          let dados = response.data;

          console.log(dados);

          this.buscarCidadePJCep(dados);

          this.formData.pj_endereco = dados.logradouro;
          this.formData.pj_endereco_bairro = dados.bairro;

          this.cep_valido = true;
        })
        .catch((error) => {
          this.isLoading = false;

          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
          console.log(error.response.data);
        });
    },

    buscarCidadePJCep(dados) {
      console.log("Buscando cidade");

      let data = {
        nome: dados.localidade,
        estado_sigla: dados.uf,
      };

      console.log(data);

      axios
        .post(`/user/cidade/buscar`, data)
        .then((response) => {
          if (response.data.success) {
            this.formData.pj_cidade_id = response.data.cidade.id;
            this.formData.pj_estado_id = response.data.estado.id;

            this.my_cidades_pj = response.data.cidades_lista;
          } else {
            this.formData.pj_cidade = response.data.cidade = "";
            this.formData.pj_estado = response.data.estado = "";
            this.formData.pj_cidade_id = "";
            this.formData.pj_estado_id = "";
          }
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
        });
    },

    closeModal() {
      console.log("Close modal");

      let btn = document.getElementById("close_editar");
      btn.click();

      this.$nextTick(function () {
        this.alterar_senha = false;
      });
    },

    validateCelular() {
      if (this.formData.telefone_celular) {
        let data = {
          telefone_celular: this.formData.telefone_celular.replace(/[^Z0-9]/g, ""),
        };

        axios
          .post("/user/cadastro/validate_celular", data)
          .then((response) => {
            console.log(response.data);

            if (response.data.success) {
              this.errors.telefone_celular = [];
            } else {
              this.errors.telefone_celular = ["Celular inválido ou já cadastrado!"];
            }
          })
          .catch((error) => {
            console.log(error);

            return false;
          });
      }
    },

    validateCPF() {
      if (this.formData.cpf) {
        let data = {
          cpf: this.formData.cpf.replace(/[^Z0-9]/g, ""),
        };

        axios
          .post("/user/cadastro/validate_cpf", data)
          .then((response) => {
            console.log(response.data);

            if (response.data.success) {
              this.errors.cpf = [];
            } else {
              this.errors.cpf = ["CPF inválido ou já cadastrado!"];
            }
          })
          .catch((error) => {
            console.log(error);

            return false;
          });
      }
    },

    async validateCPFConjuge() {
      if (
        (this.formData.estado_civil == "casado" ||
          this.formData.estado_civil == "uniao_estavel" ||
          this.formData.estado_civil == "solteiro_com_uniao_estavel") &&
        this.formData.cadastro_tipo == "pf"
      ) {
        if (this.formData.conjuge_cpf) {
          let data = {
            cpf: this.formData.conjuge_cpf.replace(/[^Z0-9]/g, ""),
          };

          let response = await axios.post("/user/cadastro/validate_cpf", data);

          console.log("Resposta conjuge");
          console.log(response.data);

          if (response.data.success) {
            this.errors.conjuge_cpf = [];
          } else {
            this.errors.conjuge_cpf = ["CPF inválido ou já cadastrado!"];
          }
        }
      } else {
        console.log("Else do conjuge");
        console.log(this.formData.estado_civil);
        this.errors.conjuge_cpf = [];
      }
    },

    buscarCep() {
      this.isLoading = true;
      this.cep_valido = false;

      let cep = this.formData.endereco_cep.replace(/[^Z0-9]/g, "");

      this.formData.endereco_num = "";

      this.getCep(cep);
    },

    getCep(cep) {
      axios
        .get("https://viacep.com.br/ws/" + cep + "/json/")
        .then((response) => {
          let dados = response.data;

          console.log(dados);

          this.buscarCidade(dados);

          this.formData.endereco = dados.logradouro;
          this.formData.endereco_bairro = dados.bairro;
          this.formData.endereco_cidade = dados.localidade;

          this.cep_valido = true;
          this.isLoading = false;
        })
        .catch((error) => {
          console.log(error);

          if (error.response && error.response.status == 400) {
            this.showErrorMessageWithButton("Ops...", "Digite um cep válido!");
            this.cep_valido = false;
            this.isLoading = false;
          } else {
            this.showErrorMessageWithButton("Ops...", "Cep inválido.");
            this.cep_valido = false;
            this.isLoading = false;
          }
        });
    },

    buscarCidade(dados) {
      let data = {
        nome: dados.localidade,
        estado_sigla: dados.uf,
      };

      console.log(data);

      axios
        .post(`/user/cidade/buscar`, data)
        .then((response) => {
          if (response.data.success) {
            console.log("Sucesso, alterando cidade");
            console.log(response.data);

            //this.cidades = response.data.cidades_lista;

            this.formData.cidade = response.data.cidade.nome;
            this.formData.cidade_id = response.data.cidade.id;

            this.formData.endereco_estado = response.data.estado.nome;
            this.formData.estado_id = response.data.estado.id;

            this.buscarCidades();
          } else {
            console.log("Erro, não alterando cidade");

            this.formData.cidade = response.data.cidade = "";
            this.formData.estado = response.data.estado = "";

            this.formData.endereco_estado = "";
            this.formData.endereco_estado_id = "";
          }

          console.log(response.data);
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
        });
    },

    formatDate(date) {
      return moment(date).format("DD/MM/YYYY");
    },

    async validateFields() {
      //let validateCPF = await this.validateCPFConjuge();

      //CALCULAR TOTAL ERROS
      let keys = Object.keys(this.errors);
      let total = 0;

      for (let i = 0; i < keys.length; i++) {
        if (this.errors[keys[i]] && this.errors[keys[i]].length && this.errors[keys[i]].length != 0) {
          total++;
        }
      }

      this.errors.total = total;

      const result = await this.v$.$validate();

      if (result && this.errors.total == 0) {
        this.$swal
          .fire({
            title: "Confirmação",
            text: "Deseja alterar o cadastro?",
            icon: "warning",
            padding: "1.5em",
            showCancelButton: true,
            cancelButtonText: "Cancelar",
            confirmButtonColor: "#4caf50",
            cancelButtonColor: "#d33",
            confirmButtonText: "Alterar",
          })
          .then((result) => {
            if (result.value) {
              console.log("Antes");
              console.log(this.user_profile.telefone_celular);
              console.log(this.formData.telefone_celular.replace(/[^Z0-9]/g, ""));

              if (this.formData.telefone_celular.replace(/[^Z0-9]/g, "") != this.user_profile.telefone_celular) {
                this.$swal
                  .fire({
                    title: "Atenção",
                    html:
                      "Devido à alteração do celular, caso confirmar, você será receberá um SMS e será direcionado para a tela de validação de SMS. Deseja continuar?",
                    icon: "warning",
                    showCancelButton: true,
                    cancelButtonText: "Cancelar",
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Sim!",
                  })
                  .then((result) => {
                    if (result.value) {
                      this.update();
                    }
                  });
              } else {
                this.update();
              }
            }
          });
      } else {
        console.log(this.v$);
      }
    },

    update() {
      this.isLoading = true;

      if (
        this.formData.estado_civil != "uniao_estavel" &&
        this.formData.estado_civil != "casado" &&
        this.formData.estado_civil != "solteiro_com_uniao_estavel"
      ) {
        this.formData.regime_casamento = null;
        this.formData.conjuge_cpf = null;
        this.formData.conjuge_rg = null;
        this.formData.conjuge_orgao_expedidor_id = null;
        this.formData.conjuge_rg_data_emissao = null;
        this.formData.conjuge_naturalidade = null;
        this.formData.conjuge_nacionalidade = null;
        this.formData.conjuge_data_nascimento = null;
        this.formData.conjuge_sexo = null;
        this.formData.conjuge_profissao = null;
        this.formData.conjuge_filiacao = null;
        this.formData.conjuge_nome_completo = null;
      }

      let data = {
        resetar_sms: this.formData.telefone_celular.replace(/[^Z0-9]/g, "") != this.user_profile.telefone_celular,
        user_id: this.user.id,
        apelido: this.formData.apelido.toUpperCase(),
        email: this.formData.user_email.toLowerCase(),
        cidade_id: this.formData.cidade_id,
        estado_id: this.formData.estado_id,
        telefone_fixo: this.formData.telefone_fixo,
        telefone_celular: this.formData.telefone_celular.replace(/[^Z0-9]/g, ""),
        filiacao: this.formData.filiacao.toUpperCase(),
        cadastro_tipo: this.formData.cadastro_tipo,
        nome_completo: this.formData.nome_completo.toUpperCase(),
        cpf: this.formData.cpf.replace(/[^Z0-9]/g, ""),
        rg: this.formData.rg.toUpperCase(),
        orgao_expedidor_id: this.formData.orgao_expedidor_id,
        rg_data_emissao: this.formatDateToSave(this.formData.rg_data_emissao),
        naturalidade: this.formData.naturalidade.toUpperCase(),
        nacionalidade: this.formData.nacionalidade.toUpperCase(),
        data_nascimento: this.formatDateToSave(this.formData.data_nascimento),
        profissao: this.formData.profissao.toUpperCase(),
        sexo: this.formData.sexo,
        estado_civil: this.formData.estado_civil,
        endereco_cep: this.formData.endereco_cep,
        endereco_num: this.formData.endereco_num.toUpperCase(),
        endereco_bairro: this.formData.endereco_bairro.toUpperCase(),
        endereco: this.formData.endereco.toUpperCase(),
        regime_casamento: this.formData.regime_casamento,
      };

      if (this.formData.endereco_complemento) {
        data.endereco_complemento = this.formData.endereco_complemento.toUpperCase();
      }

      if (this.formData.cadastro_tipo == "pj") {
        data.pj_razao_social = this.formData.pj_razao_social.toUpperCase();
        data.pj_nome_fantasia = this.formData.pj_nome_fantasia.toUpperCase();
        data.pj_cnpj = this.formData.pj_cnpj;
        data.pj_endereco = this.formData.pj_endereco.toUpperCase();
        data.pj_endereco_cep = this.formData.pj_endereco_cep;
        data.pj_endereco_num = this.formData.pj_endereco_num.toUpperCase();
        data.pj_endereco_bairro = this.formData.pj_endereco_bairro.toUpperCase();
        data.pj_estado_id = this.formData.pj_estado_id;
        data.pj_cidade_id = this.formData.pj_cidade_id;

        if (this.formData.pj_endereco_complemento) {
          data.pj_endereco_complemento = this.formData.pj_endereco_complemento.toUpperCase();
        }
      }

      if (
        (this.formData.estado_civil == "casado" ||
          this.formData.estado_civil == "uniao_estavel" ||
          this.formData.estado_civil == "solteiro_com_uniao_estavel") &&
        this.formData.cadastro_tipo == "pf"
      ) {
        data.conjuge_nome_completo = this.formData.conjuge_nome_completo.toUpperCase();
        data.conjuge_cpf = this.formData.conjuge_cpf.replace(/[^Z0-9]/g, "");
        data.conjuge_rg = this.formData.conjuge_rg.toUpperCase();
        data.conjuge_orgao_expedidor_id = this.formData.conjuge_orgao_expedidor_id;
        data.conjuge_rg_data_emissao = this.formatDateToSave(this.formData.conjuge_rg_data_emissao);
        data.conjuge_naturalidade = this.formData.conjuge_naturalidade.toUpperCase();
        data.conjuge_nacionalidade = this.formData.conjuge_nacionalidade.toUpperCase();
        data.conjuge_data_nascimento = this.formatDateToSave(this.formData.conjuge_data_nascimento);
        data.conjuge_sexo = this.formData.conjuge_sexo;
        data.conjuge_profissao = this.formData.conjuge_profissao.toUpperCase();
        data.conjuge_filiacao = this.formData.conjuge_filiacao.toUpperCase();
      }

      console.log("CRIANDO");
      console.log(data);

      axios
        .post(`/user/cadastro/update`, data)
        .then((response) => {
          this.isLoading = false;

          if (response.data.success) {
            this.showSuccessMessageWithButtonAndReloadIfConfirm("Sucesso", "Cadastro atualizado!");
          } else {
            this.showErrorMessageWithButton("Ops...", response.data.msg);
          }
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
          this.isLoading = false;
        });
    },

    formatFromDb(date) {
      if (date) {
        return moment(date, "yyyy-MM-DD").format("DD/MM/yyyy");
      } else {
        return null;
      }
    },

    formatDateToSave(date) {
      if (date) {
        return moment(date, "DD/MM/yyyy").format("yyyy-MM-DD");
      } else {
        return null;
      }
    },

    buscarCidades() {
      this.isLoading = true;

      let data = {
        estado_id: this.formData.estado_id,
      };

      console.log("CRIANDO");
      console.log(data);

      axios
        .post(`/user/endereco/cidades_por_estado`, data)
        .then((response) => {
          this.my_cidades = response.data.cidades;

          console.log(response.data);

          this.isLoading = false;
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
          this.isLoading = false;
        });
    },

    buscarCidadePJ() {
      this.isLoading = true;

      let data = {
        estado_id: this.formData.pj_estado_id,
      };

      console.log(data);

      axios
        .post(`/admin/endereco/cidades_por_estado`, data)
        .then((response) => {
          this.my_cidades_pj = response.data.cidades;

          this.formData.pj_cidade_id = null;

          this.isLoading = false;
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
        });
    },
  },
};
</script>

<style scoped>
.btn-danger:hover {
  color: #fff;
  background-color: #d2322d !important;
  border-color: #ac2925 !important;
}

.green {
  background-color: rgb(214, 251, 228);
}

strong {
  margin-right: 3px;
}

p {
  margin-top: -10px;
}

.check-card {
  width: 100%;
  height: 250px;
  text-align: center;
  cursor: pointer;
}

img {
  max-width: 100%;
  max-height: 100%;
}

textarea:focus {
  border-color: gray;
}

.rejeitado {
  border-style: solid;
  border-width: thin;
  border-color: red;
}

.aprovado {
  border-style: solid;
  border-width: thin;
  border-color: green;
}

.modal-content {
  width: 1300px;
  margin-left: -330px;
}

@media screen and (max-width: 1200px) {
  .modal-content {
    width: 1100px;
    margin-left: -50px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 800px) {
  .modal-content {
    width: 600px;
    margin-left: -50px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 600px) {
  .modal-content {
    width: 100%;
    margin-left: 0;
    margin-bottom: 100px;
  }
}
</style>
